import './component.scss'

var $ = require('jquery')

$(() => {
  const ga_send_url = $('#request-url').val()
  const ga_label = $('.ga-label')[0].value
  const pc_device_name = $('.pc-device-name')[0].value
  const sp_device_name = $('.sp-device-name')[0].value

  function sendGaForPc () {
    ga('send', 'event', 'click', ga_send_url, pc_device_name + '_' + ga_label)
  }
  function sendGaForSp () {
    ga('send', 'event', 'click', ga_send_url, sp_device_name + '_' + ga_label)
  }

  $('.pc-ga-send-subsidies-detail-card-button').on('click', sendGaForPc)
  $('.sp-ga-send-subsidies-detail-card-button').on('click', sendGaForSp)
  $('.pc-ga-send-subsidies-detail-card-company-button').on('click', sendGaForPc)
  $('.sp-ga-send-subsidies-detail-card-company-button').on('click', sendGaForSp)
})
